export const QA_NAME_CONTRACT_CREATION_MODAL = 'contractCreationModal'
